import { useTranslation } from "react-i18next";

interface InspireHeroProps {
	/** Photos on the projects loaded so far. */
	photoCount: number;
	/** Distinct designers on the projects loaded so far. */
	designerCount: number;
	/** Public projects in all, as the server counts them. */
	projectCount: number;
	/** More projects than are loaded exist, so the two loaded counts are minimums. */
	hasMore: boolean;
	/** False in the Saved view, where the counts above describe the browse list. */
	showCounts?: boolean;
}

export function InspireHero({
	photoCount,
	designerCount,
	projectCount,
	hasMore,
	showCounts = true,
}: InspireHeroProps) {
	const { t } = useTranslation();
	return (
		<section className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr] items-end gap-8 pt-12 pb-6">
			<div>
				<p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-dashboard-muted">
					VOL. III · CHAPTER II · THE ARCHIVE
				</p>

				<h1 className="mt-4 font-display text-[48px] sm:text-[72px] lg:text-[96px] leading-[0.95] font-medium tracking-[-0.03em] text-dashboard-text text-balance">
					Rooms that{" "}
					<span className="font-display text-[48px] sm:text-[72px] lg:text-[96px] font-medium italic tracking-[-0.005em] text-dashboard-accent-display">
						stir
					</span>{" "}
					you.
				</h1>
			</div>

			{showCounts && (
				<div className="flex gap-9 border-t border-dashboard-border-light pt-5 pb-3">
					<div>
						<div className="font-display text-[32px] sm:text-[38px] leading-none font-medium tracking-tight text-dashboard-text tabular-nums">
							{photoCount.toLocaleString()}
							{hasMore && "+"}
						</div>

						<p className="font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-dashboard-muted">
							{t("inspire.photosShown", { count: designerCount })}
						</p>
					</div>

					<div>
						<div className="font-display text-[32px] sm:text-[38px] leading-none font-medium tracking-tight text-dashboard-text tabular-nums">
							{projectCount}
						</div>

						<p className="font-mono text-[9px] font-semibold uppercase tracking-[0.2em] text-dashboard-muted">
							PROJECTS
						</p>
					</div>
				</div>
			)}
		</section>
	);
}
